import { render, staticRenderFns } from "./SiteCustomization.vue?vue&type=template&id=64eb88bb"
import script from "./SiteCustomization.vue?vue&type=script&lang=js"
export * from "./SiteCustomization.vue?vue&type=script&lang=js"
import style0 from "./SiteCustomization.vue?vue&type=style&index=0&id=64eb88bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports